import { renderDate } from '../utility/personTabGridHelper';

export const CONTACT_GRID_COLUMNS = [
  { field: 'ptsInfoID', headerName: 'Info ID', width: 130 },
  { field: 'ContactMethod', headerName: 'Contact Method', width: 170 },
  { field: 'MethodType', headerName: 'Type', width: 150 },
  { field: 'Info', headerName: 'Info', width: 220 },
  { field: 'IsDefault', headerName: 'Is Default', width: 120, type: 'boolean' },
  { field: 'Created', headerName: 'Created', width: 180, valueFormatter: renderDate },
  { field: 'CreatedBy', headerName: 'Created By', width: 160 },
  { field: 'Updated', headerName: 'Updated', width: 180, valueFormatter: renderDate },
  { field: 'UpdatedBy', headerName: 'Updated By', width: 160 },
];
